<template>
    <div
        class="d-flex align-items-center justify-content-between border-bottom py-1"
    >
        <span>{{ fileName }}</span>
        <div
            v-if="hasFile"
            class="ml-1 text-nowrap"
        >
            <b-button
                class="btn-icon mr-50"
                variant="primary"
                @click="$emit('preview', document)"
            >
                <feather-icon icon="EyeIcon" />
            </b-button>
            <b-button
                class="btn-icon"
                variant="primary"
                :disabled="downloading"
                @click="download"
            >
                <b-spinner
                    v-if="downloading"
                    small
                />
                <feather-icon
                    v-else
                    icon="DownloadCloudIcon"
                />
            </b-button>
        </div>
    </div>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'

export default {
    components: { BButton, BSpinner },
    props: {
        document: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            downloading: false,
        }
    },
    computed: {
        fileName() {
            return this.hasFile
                ? this.document.file.name
                : '—'
        },
        hasFile() {
            return Boolean(this.document.file && this.document.file.name)
        },
    },
    methods: {
        download() {
            this.downloading = true
            this.$emit('download', this.document, () => {
                this.downloading = false
            })
        },
    },
}
</script>
